import { useLocation } from "react-router-dom";
import { useMemo } from "react";

const useSeoPageTypeFromPathname = () => {
  const { pathname } = useLocation();

  const seoPageType = useMemo(() => {
    if (!pathname.includes("/portals/seoSettings")) return null;

    const mapping: Record<string, string> = {
      "pages/index-page": "INDEX_PAGE",
      "pages/news": "NEWS",
      "pages/articles": "ARTICLES",
      "pages/interviews": "INTERVIEWS",
      "pages/reports": "REPORTS",
      "pages/white-papers": "WHITE_PAPERS",
      "pages/events": "EVENTS",
      "pages/webinars": "WEBINARS",
      "pages/videos": "VIDEOS",
      "pages/hospital-profiles": "HOSPITALS",
      "pages/company-profiles": "COMPANIES",
      "pages/contact-us": "CONTACT",
      "services/ivf": "IVF",
      "services/iui": "IUI",
      "services/icsi": "ICSI",
      "services/sperm-egg-freezing": "SPERM_EGG_FREEZING",
      "services/surrogacy": "SURROGACY",
      "services/art": "ART",
    };

    // Extract the relevant part of the path after /portals/seoSettings/
    const pathParts = pathname.split("/portals/seoSettings/");
    if (pathParts.length < 2) return "DEFAULT";

    const seoPath = pathParts[1].split("/")[0]; // Get the first part after seoSettings
    const fullPath = pathParts[1].split("?")[0]; // Remove query params if any

    // First try exact match for the full path
    if (mapping[fullPath]) {
      return mapping[fullPath];
    }

    // Then try matching just the first part (like 'pages' or 'services')
    if (mapping[seoPath]) {
      return mapping[seoPath];
    }

    return "DEFAULT";
  }, [pathname]);

  return seoPageType;
};

export default useSeoPageTypeFromPathname;
